/** Clave de sessionStorage para indicar que la redirección al login fue por sesión caducada. */
export const SESSION_EXPIRED_STORAGE_KEY = 'auth:session-expired';
